module.exports = __webpack_public_path__ + "core-img/icons.163c2f3d418afe96a14a343215cdd18b.png";


//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/gfx/icons.png
// module id = 80
// module chunks = 0